import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { translateBlockValue } from 'i18n';
import {
    InscriptionStatusFields,
    InscriptionT,
} from 'routes/BudgetModule/shared/entities/inscription';
import { CadrageEchartProps, customizePieTooltip } from './eChartsHelpers';
import { getStatusField } from 'routes/BudgetModule/shared/phases/phase';
import { useGetPhases } from 'routes/BudgetModule/shared/phases/hook';

type Props = {
    inscriptionsData: InscriptionT[];
    budgetProposal: BudgetProposalT;
    height: number;
    width: number;
};

export const InscriptionStatusPieChart = ({
    inscriptionsData,
    budgetProposal,
    height,
    width,
}: Props) => {
    const { phase } = budgetProposal;
    const { data: phasesSettings = [] } = useGetPhases();
    const statusField = getStatusField(phasesSettings, phase);

    const inscriptionsStatus: Record<string, number> = {};

    inscriptionsData.forEach((inscription: InscriptionT) => {
        const status = inscription[statusField as InscriptionStatusFields];
        if (inscriptionsStatus[status]) {
            inscriptionsStatus[status] += 1;
        } else {
            inscriptionsStatus[status] = 1;
        }
    });

    const data = Object.entries(inscriptionsStatus).map(
        (inscriptionStatus) => ({
            value: inscriptionStatus[1],
            name: translateBlockValue(inscriptionStatus[0]),
        }),
    );

    const option = {
        tooltip: {
            trigger: 'item',
            formatter: (value: CadrageEchartProps) =>
                customizePieTooltip({ value }),
        },
        grid: {
            bottom: '0%',
            containLabel: true,
        },
        series: [
            {
                type: 'pie',
                radius: '75%',
                data,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };

    return <ReactEcharts option={option} style={{ height, width }} />;
};
